export type TCalculateTotalAllBrandsParams = {
  a3AllBrands: number
  a4AllBrands: number
}
export const calculateTotalAllBrands = (brands: TCalculateTotalAllBrandsParams) => {
  return brands.a3AllBrands + brands.a4AllBrands
}
